import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Auth } from 'aws-amplify';

import { validEmail } from '../helpers/ConfigApi';
import { useInterval } from "../hooks/useInterval";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from "@material-ui/core/Divider";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const CircularProgressWithLabel = (props) => {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="static" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="h6" component="div" color="textPrimary">{props.label}</Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  grid: {
    marginTop: theme.spacing(10)
  },
  paper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(6)
  },
  msg: {
    marginTop: '12px',
    color: theme.palette.error.main
  },
  progress: {
    marginTop: '8px'
  },
  helper: {
    marginBottom: theme.spacing(2)
  },
  button: {
    marginBottom: theme.spacing(1)
  },
  label: {
    paddingTop: theme.spacing(5)
  },
  buttons: {
    marginTop: theme.spacing(1)
  },
  formGroup: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  subscription: {
    textTransform: 'uppercase'
  },
  image: {
    width: '100%',
    height: 'auto'
  }
}));

const Register = (props) => {
  const [user, setUser] = useState();
  const [code, setCode] = useState("");
  const [firstname, setFirstname] = useState("");
  const [jobtitle, setJobTitle] = useState("");
  const [phone, setPhone] = useState("");
  const [surname, setSurname] = useState("");
  const [organisation, setOrganisation] = useState("");
  const [locale, setLocale] = useState("");
  const [subscription1, setSubscription1] = useState(false);
  const [subscription2, setSubscription2] = useState(false);
  const [subscription3, setSubscription3] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [errorFirstname, setErrorFirstname] = useState("");
  const [errorSurname, setErrorSurname] = useState("");
  const [errorJobTitle, setErrorJobTitle] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [errorOrganisation, setErrorOrganisation] = useState("");
  const [errorLocale, setErrorLocale] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [errorPassword2, setErrorPassword2] = useState("");
  const [formMsg, setFormMsg] = useState("Please enter your details ...");
  const [isWaiting, setIsWaiting] = useState(false);
  const [codeSentAt, setCodeSentAt] = useState(0);
  const [progessLabel, setProgressLabel] = useState(0);
  const [progressValue, setProgressValue] = useState(0);

  const history = useHistory();

  const validateRegistrationForm = () => {
    setFormMsg("Please correct your details ...");
    setErrorFirstname("");
    setErrorSurname("");
    setErrorJobTitle("");
    setErrorPhone("");
    setErrorOrganisation("");
    setErrorLocale("");
    setErrorEmail("");
    setErrorPassword("");
    setErrorPassword2("");
    if (firstname.length === 0) {
      setErrorFirstname("Enter your first name.");
      return false;
    }
    // if (!validateName(firstname)) {
    //   setErrorFirstname("First name can only contain letters.");
    //   return false;
    // }
    if (surname.length === 0) {
      setErrorSurname("Enter your surname.");
      return false;
    }
    // if (!validateName(surname)) {
    //   setErrorSurname("Surname can only contain letters.");
    //   return false;
    // }
    if (phone.length === 0) {
      setErrorPhone("Enter your phone number.");
      return false;
    }
    if (!validatePhone(phone)) {
      setErrorPhone("Enter your phone number: eg. +61400123456");
      return false;
    }
    if (locale.length === 0) {
      setErrorLocale("Select your State.");
      return false;
    }
    if (organisation.length === 0) {
      setErrorOrganisation("Enter your organisation.");
      return false;
    }
    // if (!validateName(organisation)) {
    //   setErrorSurname("Organisation can only contain letters.");
    //   return false;
    // }
    if (jobtitle.length === 0) {
      setErrorJobTitle("Enter your job title.");
      return false;
    }
    if (!validateName(jobtitle)) {
      setErrorSurname("Job Title can only contain letters.");
      return false;
    }
    if (email.length === 0) {
      setErrorEmail("Enter an email address.");
      return false;
    }
    if (!validateEmail(email)) {
      setErrorEmail("Enter a valid email address.");
      return false;
    }
    if (email.indexOf("@") === -1 || email.length <= 3) {
      setErrorEmail("Enter a valid email address.");
      return false;
    }
    if (!validEmail(email)) {
      setErrorEmail(`Please register with a valid '${props.config.banner.imageAlt}' email address.`);
      return false;
    }
    if (password.length === 0) {
      setErrorPassword("Enter a password.");
      return false;
    }
    if (password !== password2) {
      setErrorPassword2("Your passwords do not match.");
      return false;
    }
    setFormMsg("");
    return true;
  };

  const validateName = (s) => {
    const re = new RegExp(`^[0-9a-z()'., _-]+$`, 'i');
    return (re.test(s));
  }

  const validatePhone = (s) => {
    const re = new RegExp(`^[0-9 _+-]+$`, 'i');
    return (re.test(s));
  }

  const validateEmail = (s) => {
    const re = new RegExp(`^[a-zA-Z0-9.!#$%&’*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$`);
    return (re.test(s));
  }

  const validateConfirmationForm = () => {
    if (code.length === 0) {
      setFormMsg("Please enter the activation code.");
      return false;
    }
    var regex = new RegExp('^[0-9]+$');
    if (!regex.test(code)) {
      setFormMsg("Please enter a valid code. Your activation code should be a 6 digit number.");
      return false;
    }
    return true;
  }

  const handleRegistrationSubmit = async (event) => {
    event.preventDefault();

    if (validateRegistrationForm()) {
      setIsWaiting(true);
      setFormMsg("Registering ...");
      try {
        let subs = [];
        if (subscription1) subs.push('newsletters');
        if (subscription2) subs.push('eDMs');
        if (subscription3) subs.push('both');
        const subscribe = subs.join(', ');
        console.log('subscribe', subscribe);

        const user = await Auth.signUp({
          username: email,
          password: password,
          attributes: {
            email: email,
            given_name: firstname,
            family_name: surname,
            locale: locale,
            'custom:phone': phone,
            'custom:organisation': organisation,
            'custom:jobtitle': jobtitle,
            'custom:subscribe': subscribe,
          }
        });
        setUser(user);
        setCodeSentAt(new Date().getTime());
        setProgressValue(100);
        setProgressLabel(15);
        setFormMsg("Please enter the activation code ...");
        setIsWaiting(false);
      } catch (e) {
        console.log(e.message);
        setFormMsg(e.message);
        setIsWaiting(false);
      }
    }
  };

  const handleConfirmationSubmit = async (event) => {
    event.preventDefault();

    if (validateConfirmationForm()) {
      setIsWaiting(true);
      setFormMsg("Activating account ...");
      try {
        await Auth.confirmSignUp(email, code);
        const user = await Auth.signIn(email, password);
        setUser(user);
        setFormMsg("");
        setIsWaiting(false);
        history.push("/event");
      } catch (e) {
        console.log(e.message);
        setFormMsg(e.message);
        setIsWaiting(false);
      }
    }
  };

  const handleResendCode = async (event) => {
    event.preventDefault();

    setIsWaiting(true);
    setFormMsg("Sending Activation Code ...");
    try {
      setCodeSentAt(new Date().getTime());
      setProgressValue(100);
      setProgressLabel(15);
      await Auth.resendSignUp(email);
      setIsWaiting(false);
      setFormMsg("Please enter the activation code ...");
    } catch (e) {
      console.log(e.message);
      setFormMsg(e.message);
      setIsWaiting(false);
    }
  };

  useInterval(() => {
    const duration = 15 * 60 * 1000; // 15 minutes
    if (codeSentAt > 0) {
      const diff = (codeSentAt + duration) - new Date().getTime();
      if (diff > 0 && diff < duration) {
        setProgressValue(Math.round((diff / duration) * 100));
        setProgressLabel(Math.round(diff / 60 / 1000));
      } else {
        setProgressValue(0);
        setProgressLabel(0);
      }
    }
  }, 5000);

  const renderRegistrationForm = () => {
    return (
      <Paper className={classes.paper}>
        <h2>Register</h2>
        <form noValidate autoComplete="off" onSubmit={handleRegistrationSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                id="firstname"
                label="First name"
                value={firstname}
                error={errorFirstname.length > 0}
                helperText={errorFirstname}
                onChange={e => setFirstname(e.target.value.trim())}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="surname"
                label="Last name"
                value={surname}
                error={errorSurname.length > 0}
                helperText={errorSurname}
                onChange={e => setSurname(e.target.value.trim())}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                id="organisation"
                label="Organisation"
                value={organisation}
                error={errorOrganisation.length > 0}
                helperText={errorOrganisation}
                onChange={e => setOrganisation(e.target.value)}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                id="jobtitle"
                label="Job Title"
                value={jobtitle}
                error={errorJobTitle.length > 0}
                helperText={errorJobTitle}
                onChange={e => setJobTitle(e.target.value)}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
                autoFocus
              />
            </Grid>
          </Grid>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                id="phone"
                label="Phone Number"
                value={phone}
                error={errorPhone.length > 0}
                helperText={errorPhone}
                onChange={e => setPhone(e.target.value.trim())}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                id="locale"
                label="Country"
                value={locale}
                error={errorLocale.length > 0}
                helperText={errorLocale}
                onChange={e => setLocale(e.target.value.trim())}
                margin="normal"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
                fullWidth
              >
                <MenuItem value='Singapore'> Singapore </MenuItem>
                <MenuItem value='Malaysia'> Malaysia </MenuItem>
                <MenuItem value='Indonesia'> Indonesia </MenuItem>
                <MenuItem value='Thailand'> Thailand </MenuItem>
                <MenuItem value='Philippines'> Philippines </MenuItem>
                <MenuItem value='Vietnam'> Vietnam </MenuItem>
                <MenuItem value='Myanmar'> Myanmar </MenuItem>
                <Divider />
                <MenuItem value='OTHER'> Other </MenuItem>
              </TextField>
            </Grid>
          </Grid>

          <FormGroup className={classes.formGroup}>
            <h4 className={classes.subscription}>Subscription</h4>
            <FormControlLabel label="Yes, sign me up for Channel Asia newsletters" control={<Checkbox checked={subscription1} onChange={e => setSubscription1(e.target.checked)} name="subscription1" />} />
            <FormControlLabel label="Yes, sign me up for 3rd party eDMs sent occasionally by Channel Asia (partner programs, product launches, trials, event invitations)" control={<Checkbox checked={subscription2} onChange={e => setSubscription2(e.target.checked)} name="subscription2" />} />
            <FormControlLabel label="Yes, sign me up for Channel Asia newsletters and 3rd party eDMs" control={<Checkbox checked={subscription3} onChange={e => setSubscription3(e.target.checked)} name="subscription3" />} />
          </FormGroup>

          <TextField
            id="email"
            label="Email"
            value={email}
            error={errorEmail.length > 0}
            helperText={errorEmail}
            onChange={e => setEmail(e.target.value.trim().toLowerCase())}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
            autoFocus
          />
          <TextField
            id="password"
            label="Password"
            type="password"
            value={password}
            error={errorPassword.length > 0}
            helperText={errorPassword}
            onChange={e => setPassword(e.target.value)}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            id="password2"
            label="Confirm Password"
            type="password"
            value={password2}
            error={errorPassword2.length > 0}
            helperText={errorPassword2}
            onChange={e => setPassword2(e.target.value)}
            margin="normal"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <FormHelperText className={classes.helper}>Your password must contain uppercase letters, lowercase letters, special characters, numbers and be at least 8 characters.</FormHelperText>
          <Grid container alignItems="flex-end">
            <Grid item style={{ flexGrow: 1, paddingBottom: '12px' }}>

              <Grid container spacing={3}>
                <Grid item>
                  <Button type="submit" variant="outlined" color="secondary" disabled={isWaiting}>Register</Button>
                </Grid>
                <Grid item style={{ width: '28px' }}>
                  {isWaiting && (
                    <CircularProgress size={20} className={classes.progress} />
                  )}
                </Grid>
                <Grid item style={{ flexGrow: 1 }}>
                  <h5 className={classes.msg}>{formMsg}</h5>
                </Grid>
              </Grid>

            </Grid>
            {/* <Grid item style={{ width: '100px' }}>
              <img src="https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/arnawards/images/sponsoredby.png" alt="sponsored by cisco" className={classes.image} />
            </Grid> */}
          </Grid>

        </form>
      </Paper>
    );
  };

  const renderConfirmationForm = () => {
    return (
      <>
        <Paper className={classes.paper}>
          <h2>Activate Account</h2>
          <p>Please check your email inbox: <b>{email}</b><br />(and spam folder) for the activation code.</p>
          <form noValidate autoComplete="off" onSubmit={handleConfirmationSubmit}>
            <TextField
              id="code"
              label="Activation Code"
              value={code}
              type="tel"
              onChange={e => setCode(e.target.value.trim())}
              margin="normal"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              fullWidth
              autoFocus
            />
            <Grid container>
              <Grid item xs={4}>
                <Button type="submit" variant="outlined" color="secondary" disabled={isWaiting}>
                  Submit
            </Button>
              </Grid>
              <Grid item xs={1}>
                {isWaiting && (
                  <CircularProgress size={20} className={classes.progress} />
                )}
              </Grid>
              <Grid item xs={7}>
                <h5 className={classes.msg}>{formMsg}</h5>
              </Grid>
            </Grid>
          </form>
        </Paper>

        <Paper className={classes.paper}>
          <h3>Activation Code</h3>
          <p>An activation code has been sent to your inbox: <b>{email}</b>.</p>
          <p>If you are unable to find this email please also check your junk email and spam folder.</p>
          <Grid container justify="space-between" alignItems="flex-end">
            <Grid item>
              <p>This activation code is valid for 15 minutes.</p>
              <Button variant="outlined" color="secondary" onClick={handleResendCode} className={classes.button}>Re-send Activation Code</Button>
            </Grid>
            <Grid item>
              {progressValue > 0 &&
                <CircularProgressWithLabel color="primary" size={60} value={progressValue} label={progessLabel} />
              }
            </Grid>
          </Grid>
        </Paper>
      </>
    );
  }

  const classes = useStyles();
  return (
    <Container>
      <Grid container justify='center'>
        <Grid item xs={12} sm={10} md={7} className={classes.grid}>
          {user ? renderConfirmationForm() : renderRegistrationForm()}
        </Grid>
      </Grid>
    </Container>

  );
};

export default Register;